import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import config from './adminConfig';
import Layout from './components/Layout';

// Opzioni per-modulo delle pagine admin condivise (vedi src/adminConfig.js):
//   resetOnNavigate  ricliccare la voce di menu chiude il form aperto
//   stickyActions    colonna azioni "sticky" (richiede le regole CSS .actions-sticky)
//   dynamicRoles     ruoli letti da getRoles() invece che statici (roleLabels.*)
//   extraStaticRoles id ruolo aggiuntivi in modalità statica (es. [3] commerciale)
//   deleteWarning    mostra l'avviso di progetti ripuliti dopo la disattivazione
//   companyPublicLink { fetchToken(id), buildUrl(token) } (solo valutatore)
//   contentClassName classe aggiunta al <main> delle pagine condivise (es. 'kernel-page' per usare
//                    components/kernelPages.css nei moduli senza queste regole nel proprio App.css)
export const adminConfig = {
  resetOnNavigate: false,
  stickyActions: false,
  dynamicRoles: false,
  extraStaticRoles: [],
  deleteWarning: false,
  companyPublicLink: null,
  contentClassName: '',
  ...config,
};

export const STATIC_ROLE_LABEL_KEY = {
  1: 'roleLabels.supporto',
  2: 'roleLabels.amministratore',
  3: 'roleLabels.commerciale',
};

// Ricliccare la voce di menu mentre si è già sulla pagina non rimonta il
// componente, ma React Router genera comunque una nuova location.key.
export function useResetOnNavigate(reset) {
  const location = useLocation();
  useEffect(() => {
    if (!adminConfig.resetOnNavigate) return;
    reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key]);
}

export function ActionsWrap({ children }) {
  return adminConfig.stickyActions ? <div className="actions-sticky">{children}</div> : <>{children}</>;
}

// Etichetta e opzioni ruolo, statiche o dinamiche a seconda del modulo.
export function makeRoleHelpers(t, roles) {
  const roleName = (roleId) => {
    if (adminConfig.dynamicRoles) return roles.find((r) => r.id === Number(roleId))?.name || roleId;
    return t(STATIC_ROLE_LABEL_KEY[roleId] || STATIC_ROLE_LABEL_KEY[2]);
  };
  // options: [{id, label}] in ordine di visualizzazione; includeSupporto decide se offrire il ruolo 1.
  const roleOptions = (includeSupporto) => {
    if (adminConfig.dynamicRoles) {
      return roles
        .filter((r) => includeSupporto || r.id !== 1)
        .slice()
        .sort((a, b) => (a.id === 1 ? 1 : b.id === 1 ? -1 : a.id - b.id))
        .map((r) => ({ id: r.id, label: r.name }));
    }
    const ids = [2, ...(includeSupporto ? [1] : []), ...adminConfig.extraStaticRoles];
    return ids.map((id) => ({ id, label: t(STATIC_ROLE_LABEL_KEY[id]) }));
  };
  return { roleName, roleOptions };
}

// Layout del modulo + classe di stile opzionale (vedi contentClassName).
export function KernelPage({ user, onLogout, children }) {
  return (
    <Layout user={user} onLogout={onLogout} contentClassName={adminConfig.contentClassName}>
      {children}
    </Layout>
  );
}
